<template>
  <div class="staff-reports">
    <div class="forms header-container">
      <h2 class="organization-name">
        {{ selectedOrgObject && selectedOrgObject.name }}
      </h2>
      <div v-if="false" class="Report__Filter">
        <md-field v-if="isStaffMember">
          <label for="selectedDateRange">Date filter</label>
          <md-select
            @input="dateRangeChanged"
            :value="selectedDateRange"
            class="box"
          >
            <md-option value="all_time">All time</md-option>
            <md-option value="year_to_date">Year to Date</md-option>
            <md-option value="custom">Custom Date Range</md-option>
          </md-select>
        </md-field>

        <div
          v-if="isCustomDatePickerVisible"
          class="Report__Filter__DateRange"
        >
          <md-field
            class="md-override Report__Filter__DateRange-field"
            md-inline
          >
            <md-datepicker
              class="md-override Report__Filter__DateRange-picker"
              v-model="selectedStartDate"
              md-immediately
            >
              <label>Start date</label>
            </md-datepicker>
          </md-field>

          <md-field
            class="md-override Report__Filter__DateRange-field"
            md-inline
          >
            <md-datepicker
              class="md-override Report__Filter__DateRange-picker"
              v-model="selectedEndDate"
              md-immediately
            >
              <label>End date</label>
            </md-datepicker>
          </md-field>
        </div>

      </div>
    </div>

    <div class="forms">
      <md-field v-if="isStaffMember">
        <label>Select Organization Dashboard</label>
        <md-select
          v-model="selectedOrg"
          name="selected-org"
          id="selected-org"
          :disabled="organizations.refreshing || loading"
        >
          <md-option
            v-for="organization in organizations.list"
            :value="organization.id"
            :key="organization.id"
          >
            {{ organization.name }}
          </md-option>
        </md-select>
      </md-field>

      <div v-if="isStaffMember" class="exports">
        <md-field>
          <label>Select Dataset for Export</label>
          <md-select v-model="selectedDataset" name="selected-export" id="selected-export">
            <md-option
              v-for="dataset in exportableDatasets"
              :value="dataset.value"
              :key="dataset.value"
            >
              {{ dataset.label }}
            </md-option>
          </md-select>
        </md-field>
        <md-button
          class="md-primary"
          @click="exportDataset"
          :disabled="exporting || !selectedDataset"
        >
          <LoadSpinner v-if="exporting" />
          <i v-else>Export</i>
        </md-button>
        <md-button class="md-primary" @click="exportAll" :disabled="exporting">
          <LoadSpinner v-if="exporting" />
          <i v-else>Export All</i>
        </md-button>
      </div>
    </div>

    <LoadSpinner v-if="organizations.refreshing || loading" style="padding: 2rem 0" />

    <div v-if="report && !organizations.refreshing && !loading" class="stat-card-container">

      <div class="stat-card-wrapper">
        <div class="FundBalance stat-card">
          <div class="icon-and-tooltip">
            <p>Current fund balance</p>
            <font-awesome-icon :icon="['far', 'question-circle']" :style="{color: '#919EAB', 'margin-left': '0.5rem'}">
            </font-awesome-icon>
            <md-tooltip class="tooltip" md-direction="top">Dollars available to grant</md-tooltip>
          </div>
          <h2 class="FundBalance__heading">{{ report.fundBalance | currency }}</h2>
          <p class="FundBalance__subtitle">As of {{ dateNow }}</p>
        </div>
      </div>

      <!-- Stat Cards - TODO: Factor these out to a component -->
      <div class="stat-card-wrapper">
        <div class="stacked-stat-cards">

          <div class="stacked-stat-card">
            <div class="icon-and-tooltip">
              <p>Total contributions</p>
              <font-awesome-icon :icon="['far', 'question-circle']" :style="{color: '#919EAB', 'margin-left': '0.5rem'}">
              </font-awesome-icon>
              <md-tooltip class="tooltip" md-direction="top"><div>Total contributions received since program launch. &#10&#13 Includes seed funds and contributions via credit/debit card, payroll deduction, additional organization contributions, and other lump-sum gifts not received via card or payroll.</div></md-tooltip>
            </div>
            <h2>{{ report.amountContributed | currency }}</h2>
          </div>

          <div class="stacked-stat-card bottom">
            <div class="icon-and-tooltip">
              <p>Total disbursements</p>
              <font-awesome-icon :icon="['far', 'question-circle']" :style="{color: '#919EAB', 'margin-left': '0.5rem'}">
              </font-awesome-icon>
              <md-tooltip class="tooltip" md-direction="top">Total dollars disbursed across all grants</md-tooltip>
            </div>
            <h2>{{ report.amountDisbursed | currency }}</h2>
          </div>


        </div>
      </div>

      <div class="stat-card-wrapper">
        <div class="stacked-stat-cards">
          <div class="stacked-stat-card">
            <div class="icon-and-tooltip">
              <p>Total number of grants</p>
              <font-awesome-icon :icon="['far', 'question-circle']" :style="{color: '#919EAB', 'margin-left': '0.5rem'}">
              </font-awesome-icon>
              <md-tooltip class="tooltip" md-direction="top">Total number of requests that were either fully or partially funded</md-tooltip>
            </div>
            <h2>{{ report.totalApprovedRequests }}</h2>
          </div>

          <div class="stacked-stat-card bottom">
            <div class="icon-and-tooltip">
              <p>Requests pending</p>
              <font-awesome-icon :icon="['far', 'question-circle']" :style="{color: '#919EAB', 'margin-left': '0.5rem'}">
              </font-awesome-icon>
              <md-tooltip class="tooltip" md-direction="top">Count of submitted requests that have not yet been decisioned</md-tooltip>
            </div>
            <h2>{{ report.requestsProcessing }}</h2>
          </div>

        </div>
      </div>
    </div>

    <div class="stat-container">
      <div
        class="tab-container"
        :selectedTabName="this.selectedTabName"
        @changed-tab="onChangedTab"
      >
        <div @click="selectTab('requests')" :class="selectedTab('requests')" name="requests">
          <div :class="this.selectedTabName == 'requests' ? 'selected-tab' : 'standard-tab'">REQUESTS</div>
        </div>
        <div  :class="selectedTab('users')" name="users">
          <div :class="this.selectedTabName == 'users' ? 'selected-tab' : 'standard-tab'" @click="selectTab('users')">USERS</div>
        </div>
        <div @click="selectTab('contributions')" :class="selectedTab('contributions')" name="contributions">
          <div :class="this.selectedTabName == 'contributions' ? 'selected-tab' : 'standard-tab'" @click="() => this.selectedTabName = 'users'">CONTRIBUTIONS</div>
        </div>
        <div @click="selectTab('trendData')" :class="selectedTab('trendData')" name="trendData">
          <div :class="this.selectedTabName == 'trendData' ? 'selected-tab' : 'standard-tab'">TREND DATA</div>
        </div>
      </div>

      <div class="requests" v-if="this.selectedTabName == 'users'">
        <h1 class="tab-name">Users</h1>
        <div class="table-headings">
          <h2 class="header">Description</h2>
          <h2 class="header">Value</h2>
        </div>
        <div v-if="report && !loading && this.selectedTabName == 'users'" class="stat-list">
          <StatDisplay
            v-for="stat in usersDescriptions(report)"
            :description="stat.title"
            :value="stat.value"
            :tooltip="stat.tooltip"
            :bottomBorder="stat.bottomBorder"
            :display="stat.display"
          />
        </div>
      </div>

      <div class="requests" v-if="this.selectedTabName == 'requests'">
        <h1 class="tab-name">Requests</h1>
        <div class="table-headings">
          <h2 class="header">Description</h2>
          <h2 class="header">Value</h2>
        </div>
        <div v-if="report && !loading && this.selectedTabName == 'requests'" class="stat-list">
          <StatDisplay
            v-for="stat in requestsDescriptions(report)"
            :description="stat.title"
            :value="stat.value"
            :formatter="stat.formatter"
            :tooltip="stat.tooltip"
            :bottomBorder="stat.bottomBorder"
            :display="stat.display"
          />
        </div>
      </div>

      <div class="requests" v-if="this.selectedTabName == 'contributions'">
        <h1 class="tab-name">Contributions</h1>
        <div class="table-headings">
          <h2 class="header">Description</h2>
          <h2 class="header">Value</h2>
        </div>
        <div v-if="report && !loading && this.selectedTabName == 'contributions'" class="stat-list">
          <StatDisplay
            v-for="stat in contributionsDescriptions(report)"
            :description="stat.title"
            :value="stat.value"
            :tooltip="stat.tooltip"
            :bottomBorder="stat.bottomBorder"
            :display="stat.display"
          />
        </div>
      </div>

      <div class="trends" v-if="this.selectedTabName == 'trendData'">
        <div class="trend-data-tab">
          <div class="trend-data-selection">
            <h1 class="tab-name trend-data">Trend Data</h1>

            <div class="trend-data">
              <md-field>
                <label>Select metric to trend</label>
                <md-select
                  v-model="selectedMetric"
                  name="selected-metric"
                  id="selected-metric"
                >
                  <md-option
                    v-for="metric in metrics"
                    :value="metric" :key="metric"
                  >
                    {{ metricNames[metric] }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
            <div class="trend-data">
              <md-field>
                <label>Timeframe</label>
                <md-select
                  v-model="selectedTimeFrame"
                  name="selected-timeframe"
                  id="selected-timeframe"
                >
                  <md-option value="monthly" key="monthly">By Month</md-option>
                  <md-option value="yearly" key="yearly">By Year</md-option>
                </md-select>
              </md-field>
            </div>
          </div>
          <Chart :key="chartKey" class="chart" :title="metricNames[selectedMetric]" :chartData="trendChart" :isDollarSignNeeded="metricPrefixes[selectedMetric]">
          </Chart>
        </div>
      </div>

      <div class="charts">
        <div class="first-col-charts" v-if="!chartsLoading && Object.keys(charts).length && !organizations.refreshing && this.selectedTabName == 'requests'">
          <div v-for="(chart, index) in [charts['events'], charts['decline']]">
            <div class="new-chart">
              <div class="new-chart__title_and_tooltip">
                <h6 class="new-chart__title">{{ chart.title }}</h6>
                <div class="icon-and-tooltip">
                  <font-awesome-icon :icon="['far', 'question-circle']" :style="{color: '#919EAB', 'margin-left': '0.5rem'}">
                  </font-awesome-icon>
                  <md-tooltip class="tooltip" md-direction="top">{{chart.tooltip}}</md-tooltip>
                </div>
              </div>
              <span class="new-chart__subtitle">{{ chart.subtitle }}</span>

              <div class="chart-pill" v-for="(value, index) in chart.data.datasets[0].data">
                <div class="pill-percent-wrapper">
                  <div class="pill-title-wrapper">
                    <div class="pill-title">{{ chart.data.labels[index] }}</div>
                  </div>
                  <div class="pill-percentage">{{value}}%</div>
                </div>
                <div class="pill">
                  <div v-if="value > 0" class="pill-fill" :style="{width: `${value}%`, 'background-color': `${chart.data.datasets[0].backgroundColor}`, 'border-color': `${chart.data.datasets[0].backgroundColor}`}" >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="second-col-charts" v-if="!chartsLoading && Object.keys(charts).length && !organizations.refreshing && this.selectedTabName == 'requests'">
          <div v-for="(chart, index) in [charts['expenses']]">
            <div class="new-chart">
              <div class="new-chart__title_and_tooltip">
                <h6 class="new-chart__title">{{ chart.title }}</h6>
                <div class="icon-and-tooltip">
                  <font-awesome-icon :icon="['far', 'question-circle']" :style="{color: '#919EAB', 'margin-left': '0.5rem'}">
                  </font-awesome-icon>
                  <md-tooltip class="tooltip" md-direction="top">{{chart.tooltip}}</md-tooltip>
                </div>
              </div>
              <span class="new-chart__subtitle">{{ chart.subtitle }}</span>

              <div class="chart-pill" v-for="(value, index) in chart.data.datasets[0].data">
                <div class="pill-percent-wrapper">
                  <div class="pill-title-wrapper">
                    <div class="pill-title">{{ chart.data.labels[index] }}</div>
                  </div>
                  <div class="pill-percentage">{{value}}%</div>
                </div>
                <div class="pill">
                  <div v-if="value > 0" class="pill-fill" :style="{width: `${value}%`, 'background-color': `${chart.data.datasets[0].backgroundColor}`, 'border-color': `${chart.data.datasets[0].backgroundColor}`}" >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Organization from '@/services/organizations'
import Report from '@/services/reporting'
import OrgChart from '@/services/charts'
import CollectionManager from '@/services/collectionManager'
import { LoadSpinner, Chart } from '@/components'
import Tab from '@/components/Tab'
import TabContainer from '@/components/TabContainer'
import StatDisplay from '@/components/staff/StatDisplay'
import { analyticsMixin } from '@/services/googleAnalytics'

const decline_reason_labels = {
  'DOCUMENTATION_INSUFFICIENT_OR_UNCLEAR': 'Insufficient documentation',
  'DUPLICATE': 'Duplicate',
  'OVER_INDIVIDUAL_LIMIT': 'Over individual limit',
  'WITHDRAWN': 'Withdrawn',
  'SUSPECTED_FRAUD': 'Suspected fraud',
  'NOT_ELIGIBLE': 'Not eligible',
  'OTHER': 'Other',
}

const metrics = [
  'amount_contributed',
  'amount_disbursed',
  'total_approved_requests',
  'amount_requested',
  'requests_received',
  'requests_fully_approved',
  'requests_declined',
  'onboarded_users',
  'onboarded_active_users',
  'credit_debit_contributions',
  'payroll_contributions',
]

const metricNames = {
  'amount_contributed': 'Total contributions',
  'amount_disbursed': 'Total disbursements',
  'total_approved_requests': 'Total number of grants',
  'amount_requested': 'Total requested',
  'requests_received': 'Requests received',
  'requests_fully_approved': 'Requests fully funded',
  'requests_declined': 'Requests declined',
  'onboarded_users': 'Onboarded users',
  'onboarded_active_users': 'Onboarded active users',
  'credit_debit_contributions': 'Credit/debit card contributions',
  'payroll_contributions': 'Payroll contributions',
  'unique_contributors': 'Unique contributors',
}

const metricPrefixes = {
  'amount_contributed': true,
  'amount_disbursed': true,
  'total_approved_requests': false,
  'amount_requested': true,
  'requests_received': false,
  'requests_fully_approved': false,
  'requests_declined': false,
  'onboarded_users': false,
  'onboarded_active_users': false,
  'credit_debit_contributions': true,
  'payroll_contributions': true,
  'unique_contributors': false,
}

export default {
  name: 'Reports',
  mixins: [analyticsMixin],
  components: {
    LoadSpinner,
    Chart,
    Tab,
    TabContainer,
    StatDisplay,
  },
  data() {
      return {
          organizations: CollectionManager.create({ ModelClass: Organization }),
          metrics: metrics,
          metricNames: metricNames,
          metricPrefixes: metricPrefixes,
          selectedOrg: null,
          report: null,
          selectedDataset: null,

          selectedDateRange: "all_time",
          isCustomDatePickerVisible: false,
          selectedStartDate: null, // forces md-datepicker to Date model
          selectedEndDate: null, // forces md-datepicker to Date model
          reportFilter: null,

          selectedTabName: "requests",
          selectedTimeFrame: 'monthly',
          exporting: false,
          loading: false,
          charts: {},
          chartsLoading: false,
          trendDataLabels: [],
          trendDataDataset: [],
          chartKey: 1,
          selectedMetric: 'amount_requested',
          trendChart: {
              name: 'Trend Data',
              title: metricNames[this.selectedMetric],
              data: {
                  datasets: [
                      {
                          data: [],
                        },
                    ],
                },
            },
        }
  },
  created() {
    this.refresh()
  },
  methods: {
    requestsDescriptions(report) {
        return [
            {
                title: "Total requested",
                value: report['amountRequested'],
                formatter: this.$options.filters.currency,
                tooltip: "Total dollars requested across all submitted requests",
                display: true
            },
            {
                title: 'Requests received',
                value: report["requestsReceived"],
                tooltip: "Count of grant requests submitted",
                bottomBorder: true,
                display: true
            },
            {
                title: 'Requests fully funded',
                value: report['requestsFullyApproved'],
                tooltip: "Count of requests where the requestor received the full dollar amount requested",
                display: true
            },
            {
                title:'Requests partially funded',
                value: report['requestsPartiallyApproved'],
                tooltip: "Count of requests where the requestor received less than the dollar amount requested. This could be because (a) they asked for more than the grant limit or more than they were eligible to receive, given their previous grant activity; or (b) their documentation was not sufficient to support funding more than what they were granted.",
                display: true
            },
            {
                title: 'Requests partially funded, pending',
                value: report['requestsPartiallyApprovedPending'],
                tooltip: "Count of requests where an initial portion of the grant has been funded, and we are awaiting additional information from the requestor to determine whether we can fund a larger portion of the request",
                display: true
            },
            {
                title: 'Requests declined',
                value: report['requestsDeclined'],
                tooltip: "Count of requests that were not funded at all",
                bottomBorder: true,
                display: true
            },
            {
                title: "Requests referred",
                value: report['referredRequestsFullyApproved'],
                tooltip: "Count of grant requests referred to sponsoring organization",
                display: this.isReferralClient
            },
            {
                title: "Referred fully funded",
                value: report['referredRequestsFullyApproved'],
                tooltip: "Count of referred requests where the requestor received the full dollar amount requested",
                display: this.isReferralClient
            },
            {
                title: "Referred partially funded",
                value: report["referredRequestsPartiallyApproved"],
                tooltip: "Count of referred requests where the requestor received less than the dollar amount requested",
                display: this.isReferralClient,
            },
            {
                title: "Referred declined",
                value: report["referredRequestsDeclined"],
                tooltip: "Count of referred requests that were not funded at all",
                display: this.isReferralClient,
                bottomBorder: true,
            },

          ]
    },
    usersDescriptions(report) {
        return [
            {
                title: 'Eligible users',
                value: report["eligibleUsers"],
                tooltip: "Total number of eligible individuals",
                bottomBorder: true,
                display: true,
            },
            {
                title: 'Onboarded users',
                value: report["onboardedUsers"],
                tooltip: "Total number of individuals who have created an account",
                bottomBorder: true,
                display: true,
              },
            {
                title: 'Onboarded active users',
                value: report["onboardedActiveUsers"],
                tooltip: "Number of onboarded individuals who are still eligible to participate",
                bottomBorder: true,
                display: true,
              },
            {
                title: 'Onboarded inactive users',
                value: report["onboardedInactiveUsers"],
                tooltip: "Number of onboarded individuals who have become ineligible to participate since onboarding",
                bottomBorder: true,
                display: true,
              },
            {
                title: "Unique requestors",
                value: report["uniqueRequestors"],
                tooltip: "Count of individuals to submit at least one grant request",
                bottomBorder: true,
                display: true,
              },
            {
                title: "Unique grantees",
                value: report["uniqueGrantees"],
                tooltip: "Unique count of requestors to receive at least one grant",
                bottomBorder: true,
                display: true,
              },
          ]
      },

      contributionsDescriptions(report) {
          return [
              {
                  title: "Seed funds",
                  value: this.$options.filters.currency(report["startingFundBalance"]),
                  tooltip: "Seed funds contributed by the sponsoring organization, and any other donors, to launch the Grant Circle",
                  display: true,
                },
              {
                  title: "Organization contributions (non-seed)",
                  value: this.$options.filters.currency(report["organizationContributions"]),
                  tooltip: "Funds contributed by the sponsoring organization after program launch (that is, non-seed)",
                  display: true,
                },
              {
                  title: "Other contributions (non-seed, non-card, non-payroll)",
                  value: this.$options.filters.currency(report["otherContributions"]),
                  tooltip: "Lump-sum contributions not received via card or payroll, from an entity other than the sponsoring organization",
                  bottomBorder: true,
                  display: true,
                },
              {
                  title: "Credit/debit card contributions",
                  value: this.$options.filters.currency(report["creditDebitContributions"]),
                  tooltip: "Total contributions received via credit/debit card",
                  display: true,
                },
              {
                  title: "Median one-time card contribution",
                  value: this.$options.filters.currency(report["medianOneTimeCardContribution"]),
                  tooltip: "Median one-time credit/debit card contribution amount",
                  display: true,
                },
              {
                  title: "One-time card contributions",
                  value: report["oneTimeCardContributors"],
                  tooltip: "Count of credit/debit card contributions",
                  display: true,
              },
              {
                  title: "Median active recurring card contribution",
                  value: this.$options.filters.currency(report["medianActiveRecurringCardContributions"]),
                  tooltip: "Median recurring credit/debit card contribution amount for those that are still active",
                  display: true,
              },
              {
                  title: "Active recurring card contributors",
                  value: report["activeRecurringCardContributors"],
                  tooltip: "Count of unique contributors with an active recurring credit/debit card contribution",
                  display: true,
                  bottomBorder: true,
              },
              {
                  title: "Payroll contributions",
                  value: this.$options.filters.currency(report["payrollContributions"]),
                  tooltip: "Total contributions received via payroll deduction",
                  display: this.selectedOrgObject.allowsPayrollRequests,
                },
              {
                  title: "Median one-time payroll contribution",
                  value: this.$options.filters.currency(report["medianOneTimePayrollContributions"]),
                  tooltip: "Median one-time payroll contribution amount",
                  display: this.selectedOrgObject.allowsPayrollRequests,
                },
              {
                  title: "One-time payroll contributions",
                  value: report["oneTimePayrollContributions"],
                  tooltip: "Count of one-time payroll contributions",
                  display: this.selectedOrgObject.allowsPayrollRequests,
                },
              {
                  title: "Median recurring payroll contribution",
                  value: this.$options.filters.currency(report["medianRecurringPayrollContributions"]),
                  tooltip: "Median recurring payroll contribution amount",
                  display: this.selectedOrgObject.allowsPayrollRequests,
                },
              {
                  title: "Recurring payroll contributors",
                  value: report["recurringPayrollContributions"],
                  tooltip: "Count of recurring payroll contributors (all-time)",
                  display: this.selectedOrgObject.allowsPayrollRequests,
                  bottomBorder: true,
                },
              {
                  title: "Unique contributors",
                  value: report["uniqueContributors"],
                  tooltip: "Count of individuals or entities that have made at least one donation via credit/debit card, payroll deduction, or lump-sum contribution (excluding sponsoring organization) de-duped by email and/or unique ID.",
                  bottomBorder: true,
                  display: true,
                },
              ]
        },
    async refresh() {
      await this.organizations.refresh()
      this.selectedOrg = this.organizations.list[0].id
    },
    selectTab(tabName) {
      this.selectedTabName = tabName

      if (tabName === 'requests' ) {
        this.trackCustomPageview('AdminReportsRequests', '/reportsRequests')
      }
      if (tabName === 'users' ) {
        this.trackCustomPageview('AdminReportsUsers', '/reportsUsers')
      }
      if (tabName === 'contributions' ) {
        this.trackCustomPageview('AdminReportsContributions', '/reportsContributions')
      }
      if (tabName === 'trendData' ) {
        this.trackCustomPageview('AdminReportsTrend', '/reportsTrend')
      }
    },
    selectedTab(tabName) {
      if (tabName == this.selectedTabName) {
          return "tab selected"
      }
      return "tab"
    },
    dateRangeChanged(value) {
      if (value == this.selectedDateRange) { return; }

      this.selectedDateRange = value;

      switch (this.selectedDateRange) {
        case "all_time":
          this.isCustomDatePickerVisible = false;
          this.setReportFilter(null);
          break;

        case "year_to_date":
          this.isCustomDatePickerVisible = false;
          const now = new Date(Date.now());
          const prevYear = now.getFullYear() - 1;
          const yearAgo = new Date(new Date(Date.now()).setFullYear(prevYear));

          const filter = {
            startDate: yearAgo,
            endDate: now
          };

          this.setReportFilter(filter);
          break;

        case "custom":
          this.isCustomDatePickerVisible = true;
          this.buildCustomDateRangeFilter();
          break;
      }
    },
    buildCustomDateRangeFilter() {
      const start = this.selectedStartDate;
      const end = this.selectedEndDate;

      if (!start || !end) {
        return
      }

      const startTimestamp = Date.parse(start);
      const endTimestamp = Date.parse(end);
      if (isNaN(startTimestamp) || isNaN(endTimestamp)) {
        return;
      }

      const startDate = new Date(startTimestamp);
      const endDate = new Date(endTimestamp);

      this.setReportFilter({ startDate, endDate });
    },
    dateValueChanged(newValue, oldValue) {
      // Work around md-datepicker giving us a string instead of a Date
      const newTimestamp = newValue ? Date.parse(newValue) : null;
      const oldTimestamp = oldValue ? Date.parse(oldValue) : null;
      if (isNaN(newTimestamp) || isNaN(oldTimestamp)) { return }

      // Work around md-datepicker firing two identical events for a single
      // change event.
      // See https://github.com/vuematerial/vue-material/issues/2103
      if (oldTimestamp == newTimestamp) { return }

      const newDate = new Date(newTimestamp);
      const oldDate = new Date(oldTimestamp);

      // Work around md-datepicker triggering two watch events with different
      // timezone data for the same change event
      if (
        oldTimestamp && newTimestamp &&
        (
          (new Date(oldTimestamp)).toDateString() == (new Date(newTimestamp)).toDateString()
        )
      ) {
        return;
      }

      this.buildCustomDateRangeFilter();
    },
    setReportFilter(filter) {
      // Setting null value clears the filter
      if (!filter) {
        this.reportFilter = null;
        return;
      }

      // Ignore incomplete filter
      if (!filter.startDate || !filter.endDate) {
        return;
      }

      // Ignore invalid filter
      if (filter.startDate > filter.endDate) {
        // @TODO: set validation error in UI
        return;
      }

      // Ignore new filter of same value as existing
      if (
        this.reportFilter &&
        filter.startDate == this.reportFilter.startDate &&
        filter.endDate == this.reportFilter.endDate
      ) {
        return;
      }

      this.reportFilter = filter;
    },
    fetchReport(org, filter) {
      this.loading = true
      this.chartsLoading = true
      Report.api
        .retrieve(org, filter)
        .then((report) => {
          this.report = report
        })
        .finally(() => {
          this.loading = false
        })

      this.getOrgChartData(org, filter);
    },
    getOrgChartData(newOrg, filter) {
      this.charts = {}
      const chartFuncs = [this.getDeclineReasons, this.getEvents, this.getExpenses]
      this.chartsLoading = true
      Promise.all(chartFuncs.map((func) => func(newOrg, filter))).then(() => {
        this.chartsLoading = false
      })
    },
    getMetricChartData(selectedOrganization, selectedMetric, selectedTimeFrame) {
      return OrgChart.api.metricChartData(selectedOrganization, selectedMetric, selectedTimeFrame).then((metricData) => {
        const trendData = Object.entries(metricData)

        var yAxisName = 'y'
        var index = 0

        if (selectedTimeFrame === 'yearly') {
          const trendLabels = [...new Set(trendData.map((datum) => datum[0]))]

          const trendedDateFormatted = trendData.reduce((previous, current, currentIndex) => {
              const datumDate = new Date(current[0])
              const year = datumDate.toLocaleString('default', { timeZone: 'utc', year: 'numeric' })

              const colors = [ '#1D5A5F', '#47B393', '#FEDA67', '#FEF1C5', '#08262A' ]

              yAxisName = `y`

              if (previous[0] && Object.keys(previous[0]).includes('data')) {
                previous[0]['data'].push({ x: year, [yAxisName]: current[1] })
              } else {
                const label = this.metricPrefixes[this.selectedMetric] ? `${metricNames[this.selectedMetric]} ($)` : `# ${metricNames[this.selectedMetric]}`
                previous[0] = { 'data': [], 'yAxisID': yAxisName, label: label, borderColor: colors[0],  backgroundColor: colors[0]  }
                previous[0]['data'].push({ x: year, [yAxisName]: current[1] })
              }

              return previous
          },
          []
          )

          this.trendChart.data.labels = trendLabels
          this.trendChart.data.datasets = trendedDateFormatted
          this.chartKey += 1
        }

        if (selectedTimeFrame === 'monthly') {
          const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
          const trendLabels = [...new Set(trendData.map((datum) => datum[0]))]

          const trendedDateFormatted = trendData.reduce((previous, current, currentIndex) => {
              const datumDate = new Date(current[0])
              const originalMonthNumber = datumDate.getMonth()
              const month = datumDate.toLocaleString('default', { timeZone: 'utc', month: 'long' })
              const year = datumDate.toLocaleString('default', { timeZone: 'utc', year: 'numeric' })

              const colors = [ '#1D5A5F', '#47B393', '#FEDA67', '#FEF1C5', '#08262A' ]

              if (currentIndex == 0) {
                previous[index] = { 'data': [], 'yAxisID': yAxisName, label: year, borderColor: colors[index],  backgroundColor: colors[index] }
              }

              if (currentIndex == 0 && month != 'January') {
                  previous[index] = { 'data': [], 'yAxisID': yAxisName, label: year, borderColor: colors[index],  backgroundColor: colors[index] }

                  for (const monthNumber in [...Array(originalMonthNumber + 1).keys()]) {
                    previous[index]['data'].push({ x: months[monthNumber], [yAxisName]: 0 })
                  }
              }

              if (month == 'January') {
                yAxisName = `y`
                index = index + 1
                previous[index] = { 'data': [], 'yAxisID': yAxisName, label: year, borderColor: colors[index],  backgroundColor: colors[index]  }
              }

              if (previous[index] && Object.keys(previous[index]).includes('data')) {
                previous[index]['data'].push({ x: month, [yAxisName]: current[1] })
              } else {
                previous[index] = {'data': []}
                previous[index]['data'].push({ x: month, [yAxisName]: current[1] })
              }

              return previous
          },
          []
          )

          this.trendChart.data.labels = months
          this.trendChart.data.datasets = trendedDateFormatted
          this.chartKey += 1
        }

        this.trendChart.title = this.metricNames[this.selectedMetric]
        this.trendChart.timeframe = this.selectedTimeFrame
      })
    },
    getDeclineReasons(newVal) {
      return OrgChart.api.declines(newVal).then((events) => {
        const labels = []
        const percentages = []
        const totals = []
        Object.keys(events.data).forEach((label) => {
          labels.push(decline_reason_labels[label])
          percentages.push(events.data[label]['percent'])
          totals.push(events.data[label]['total'])
        })
        this.charts["decline"] = {
          name: 'chart3',
          title: 'Decline reasons',
          subtitle: '(as % of declined requests)',
          tooltip: 'Reasons requests were declined, expressed as a fraction of total requests declined',
          data: {
            labels: labels,
            datasets: [
              {
                data: percentages,
                backgroundColor: '#1D5A5F',
              },
            ],
          },
        }
      })
    },
    getEvents(newVal, filter) {
      return OrgChart.api.events(newVal, filter).then((events) => {
        const labels = []
        const percentages = []
        events.data.forEach((event) => {
          const shortenedLabel = event.label.split('(')[0]
          labels.push(shortenedLabel)
          percentages.push(event.percentage)
        })
        this.charts['events'] = {
          name: 'chart1',
          title: 'Precipitating events',
          subtitle: '(as % of total requests, multi-select possible)',
          tooltip: 'Emergency event types selected in grant requests, expressed as a fraction of total requests, multi-select possible',
          data: {
            labels: labels,
            datasets: [
              {
                data: percentages,
                backgroundColor: '#1D5A5F',
              },
            ],
          },
        }
      })
    },
    getExpenses(newVal, filter) {
      return OrgChart.api.expenses(newVal, filter).then((expenses) => {
        const labels = []
        const percentages = []
        expenses.data.forEach((expense) => {
          const shortenedLabel = expense.label.split('(')[0]
          labels.push(shortenedLabel)
          percentages.push(expense.percentage)
        })
        this.charts['expenses'] = {
          name: 'chart2',
          title: 'Expenses',
          tooltip: 'Expense types selected in grant requests, expressed as a fraction of total requests, multi-select possible',
          subtitle: '(as % of total requests, multi-select possible)',
          data: {
            labels: labels,
            datasets: [
              {
                data: percentages,
                backgroundColor: '#FEDA67',
              },
            ],
          },
        }
      })
    },
    onChangedTab(newTab) {
      this.selectedTabName = newTab
    },
    exportDataset() {
      if (!this.selectedDataset) {
        return
      }
      this.exporting = true
      Report.api.exportDataset(this.selectedDataset).finally(() => {
        this.exporting = false
      })
    },
    exportAll() {
      this.exporting = true
      const datasets = this.exportableDatasets

      const promises = datasets.map((dataset) => {
        return Report.api
          .exportDataset(dataset.value)
          .then((response) => {
            let hiddenElement = document.createElement('a')
            hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(response.data)
            hiddenElement.target = '_blank'
            hiddenElement.download = `${dataset.value}_DATASET__${new Date().toUTCString()}.csv`
            hiddenElement.click()
          })
          .catch((err) => {
            this.exporting = false
          })
      })

      Promise.all(promises).then((responses) => {
        this.exporting = false
      })
    },
  },
  computed: {
    isStaffMember() {
      return this.$store.state.user.isStaff
    },
    exportableDatasets() {
      if (this.isStaffMember) {
        return Report.options.EXPORTABLE_DATASETS.concat(Report.options.STAFF_ONLY_DATASETS)
      }

      return Report.options.EXPORTABLE_DATASETS
    },
    selectedOrgObject() {
      return this.organizations.list.find((org) => org.id === this.selectedOrg)
    },
    isReferralClient() {
      return this.selectedOrgObject && this.selectedOrgObject.isReferralOrganization
    },
    dateNow() {
      const now = new Date();

      const yyyy = now.getFullYear().toString(10);
      const month = (now.getMonth() + 1).toString(10);
      const day = now.getDate().toString(10);

      const mm = month.length == 1 ? `0${month}` : month;
      const dd = day.length == 1 ? `0${day}` : day;

      return mm + '/' + dd + '/' + yyyy;
    }
  },
  watch: {
    selectedOrg(newOrg) {
      this.fetchReport(newOrg, this.reportFilter);
      this.getMetricChartData(newOrg, this.selectedMetric, this.selectedTimeFrame)
    },
    selectedStartDate(newStart, oldStart) {
      this.dateValueChanged(newStart, oldStart);
    },
    selectedEndDate(newEnd, oldEnd) {
      this.dateValueChanged(newEnd, oldEnd);
    },
    reportFilter(newFilter) {
      this.fetchReport(this.selectedOrg, this.reportFilter);
    },
    selectedMetric(newVal) {
      this.getMetricChartData(this.selectedOrg, newVal, this.selectedTimeFrame)
    },
    selectedTimeFrame(newVal) {
      this.getMetricChartData(this.selectedOrg, this.selectedMetric, newVal)
    }
  },
}
</script>

<style lang="scss" scoped>
@import '../../styles/variables';
@import '../../styles/mixins/cards';
@import '../../styles/mixins/containers';


.FundBalance > .FundBalance__heading {
  margin-bottom: 0px;
}

.FundBalance > .FundBalance__subtitle {
  font-size: 12px;
  color: #919EAB;
  margin: 8px 0 0 0;
  font-weight: 600;
}

.organization-name {
  color: #212B36;
  font-size: 36px;
  margin-top: 2rem;
}

.staff-reports {
  @include screen-container;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-self: stretch;
}

.Report__Filter__DateRange {
  margin-bottom: 24px;
}

.md-override.Report__Filter__DateRange-field {
  margin: 8px 0 0 0;
  padding: 0;
}

.md-override.Report__Filter__DateRange-picker {
  margin: 0;
}

.stat-container {
  display: flex;
  margin-left: 1.5rem;
  margin-right: 1.5rem;
  flex-wrap: wrap;
  min-width: 250px;
  border-radius: 12px;
  box-shadow: 0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15);

  .tab-name {
    text-align: unset;
    padding: 1.5rem;


  }

  .table-headings {
    display: flex;
    margin-left: 1.5rem;
    margin-right: 1.5rem;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-bottom-width: 2px;
    border-bottom-color: #DFDFE0;
    border-bottom-style: solid;

    .header {
      font-size: 16px;
    }
  }

  .standard-tab {
    font-size: 12px;
    font-weight: 600;
    color: #637381;
  }

  .trend-data {
    width: 100%;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .selected-tab {
    font-size: 12px;
    font-weight: 600;
    color: #212B36;
  }

  .requests {
    width: 50%;
  }

  .new-chart {
    border-radius: 12px;
    margin-top: 1.5rem;
    padding: 1.5rem;
    box-shadow: 0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15);
    border-style: solid;
    border-width: 1px;
    border-color: #DFDFE0;

    &__title_and_tooltip {
      margin-bottom: 0.5rem;
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    &__subtitle {
      font-size: 12px;
      color: #919EAB;
      display: inline-block;
      margin-bottom: 1rem;
    }

    &__title {
      margin-bottom: 0;
      color: $black;
    }

    .chart-pill {
      display: flex;
      flex-direction: column;
    }

    .pill-title {
      font-size: 12px;
    }

    .pill {
      height: 12px;
      border-radius: 12px;
      border-color: #DFDFE0;
      border-width: 1px;
      border-style: solid;
      background-color: rgba(0,0,0,0.1);
      width: 100%;
      display: flex;
      align-items: center;
    }

    .pill-percent-wrapper {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-top: .5rem;
      margin-bottom: .15rem;
    }

    .pill-percentage {
      font-size: 12px;
      font-weight: 700;
    }

    .pill-data-extra {
      font-size: 12px;
      margin-left: .25rem;
      font-weight: 700;
    }

    .pill-title-wrapper {
      font-size: 12px;
      display: flex;
      font-weight: 700;
    }

    .pill-fill {
      height: 12px;
      border-top-left-radius: 12px;
      border-bottom-left-radius: 12px;
      border-style: solid;
      border-width: 1px;
      border-color: #1D5A5F;
      background-color: #1D5A5F;
    }
  }

  .first-col-charts {
    margin-bottom: 1.5rem;
  }

  .second-col-charts {
    margin-bottom: 1.5rem;
  }

  .charts {
    width: 50%;
    display: grid;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;
  }
}

.stat-card-container {
  display: flex;
  flex-wrap: wrap;
  min-width: 250px;

  @media (min-width: $mobile-break-point) {
    display: flex;
    flex-wrap: wrap;
    min-width: 250px;
    width: 100%;
    height: 100%;
  }

  .stacked-stat-cards {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-width: 250px;

    .stacked-stat-card {
      @include card;
      width: 100%;
      padding: 1.5rem;
      width: 100%;
      height: 100%;
      border-radius: 12px;
      box-shadow: 0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15);

      &.bottom {
        margin-top: 1.5rem
      }


      & > p {
        margin: 1rem 0;
      }

      & strong {
        font-weight: 700;
      }
    }
  }
}

.stat-card-wrapper {
  width: 33.33%;
  padding: 1.5rem;
  display: flex;
  min-width: 250px;
}

.icon-and-tooltip {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.tooltip {
  max-width: 250px;
  background-color: black;
  color: white;
}

.stat-card {
  @include card;
  padding: 1.5rem;
  min-width: 250px;
  width: 100%;
  height: 100%;
  border-radius: 12px;
  box-shadow: 0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15);

  & > p {
    margin: 1rem 0;
  }

  & strong {
    font-weight: 700;
  }
}

.tab-container {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  display: flex;
  flex-direction: row;
  width: 100%;
  border-bottom: solid;
  border-bottom-width: 1px;
  border-bottom-color: #DFDFE0;
}

.tab {
  padding: 1.5rem;
  cursor: pointer;

  &.selected {
    border-bottom: solid;
    border-bottom-width: 1px;
    border-bottom-color: black;
  }
}

.stat-list {
  padding: 1.5rem;
}


.trends {
  width: 100%;

  .trend-data-tab {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
  }

  .trend-data-selection {
    width: 40%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

.chart {
  margin: 1.5rem;
  width: 60%;
}

.md-field {
  max-width: 25rem;
  margin-right: 3rem;
  margin-bottom: 0;
}

.forms {
  display: flex;
  flex-flow: row;
  margin-bottom: 24px;
  padding-left: 1.5rem;
  padding-right: 1.5rem;

  .exports {
    margin-left: auto;
    display: flex;
    flex-flow: row;
    align-items: center;

    .md-button {
      width: 8rem;
    }
  }
}

.md-tooltip {
  height: auto;
  white-space: normal;
  font-size: 12px;
  max-width: 300px;
}
</style>
